@if (buttons) {
    @for (button of buttons; track button; let i = $index) {
        @if (computedFields[i].visible !== undefined ? computedFields[i].visible : true) {
            <button
                [disabled]="computedFields[i].disabled || button.disabled"
                [title]="computedFields[i].tooltip ?? button.tooltip | translate"
                class="button button-renderer small"
                (click)="btnClickHandler(i)"
            >
                <i [ngClass]="'far fa-fw fa-' + button.icon"></i>
            </button>
        } @else if (invisibleButtonPlaceholder) {
            <button class="button button-renderer small placeholderButton"></button>
        }
    }
}
